import { showDictionaryPaymentSuccessToast } from './sessionToast';

/** Set in UpgradeBookAccount before redirect to payment gateway; consumed on success landing. */
export const DICTIONARY_PAYMENT_RETURN_FLAG = 'aaz_dictionary_payment_return';

/** True only when the user is about to land on /subscriptionSuccess after the payment redirect flow. */
export function isDictionaryPaymentReturnPending() {
    if (typeof window === 'undefined') return false;
    return Boolean(window.sessionStorage.getItem(DICTIONARY_PAYMENT_RETURN_FLAG));
}

const SESSION_KEYS_TO_CLEAR = [
    'jwt',
    'id',
    'account',
    'token',
    'userName',
    'name',
    'lastname',
    'email',
    'picture',
    'linkedBookCode',
];

export function clearSessionAfterDictionaryPayment() {
    if (typeof window === 'undefined') return;
    try {
        SESSION_KEYS_TO_CLEAR.forEach((key) => window.localStorage.removeItem(key));
    } catch {
        /* ignore */
    }
}

/**
 * If the user is returning from the dictionary payment flow, clears the flag,
 * shows the “session ended, sign in again” toast, and wipes local session.
 * @returns {boolean} true when a payment return was handled
 */
export function consumeDictionaryPaymentReturn(language) {
    if (typeof window === 'undefined') return false;
    const flag = window.sessionStorage.getItem(DICTIONARY_PAYMENT_RETURN_FLAG);
    if (!flag) return false;
    window.sessionStorage.removeItem(DICTIONARY_PAYMENT_RETURN_FLAG);
    showDictionaryPaymentSuccessToast(language);
    clearSessionAfterDictionaryPayment();
    return true;
}
